import React from 'react'

import Tooltip from 'antd/es/tooltip';

import { Title } from 'components/Text';
import { Space } from 'components/layout'
import Icon from 'components/Icon';
import StyledCard from 'components/Card';


const CartFlowCard = ({ title, info, children, titleExtra = null, ...rest }) => {
  return (
    <StyledCard {...rest}>
      <Space>
        <Title level={4} style={{ margin: 0 }}>
          {title}
        </Title>
        <Tooltip title={info}>
          <Icon
            name="info"
            size={16}
            color="#B9C2C9"
            style={{
              marginTop: '4px',
            }}
          />
        </Tooltip>
        {titleExtra}
      </Space>
      {children}
    </StyledCard>
  );
};

export default CartFlowCard;